import { DashboardFolder, ReFolderV2 } from "@/services/cloudchipr.api";
import { HierarchyFolderItem } from "@/store/navigation/utils/types";

export const isHierarchyFolder = (
  data: HierarchyFolderItem,
): data is DashboardFolder | ReFolderV2 => {
  return "items" in data;
};
